module.exports = __webpack_public_path__ + "static/media/spilceOne_sl@2x.84f47557.png";